import { z } from 'zod';

import { PostfixFunctionSchema, PostfixRegexSchema } from '../postfixLogic';

import { PostfixComparatorsSchema } from './comparators';
import { PostfixComparisonAttributesSchema } from './comparisonAttribute';
import { PostfixPropertyPathSchema } from './propertyPath';

export const PostfixOperandSchema = z.object({
  propertyPath: PostfixPropertyPathSchema,
  comparator: PostfixComparatorsSchema,
  ignoreCase: z.boolean().optional(),
  comparisonAttribute: PostfixComparisonAttributesSchema.optional().default('value'),
  comparisonValue: z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.union([z.string(), z.number(), z.boolean()])),
    PostfixFunctionSchema,
    PostfixRegexSchema,
    PostfixPropertyPathSchema,
  ]),
});

export type PostfixOperand = z.infer<typeof PostfixOperandSchema>;
